import { useEffect, useState } from 'react';
import { Modal } from '@zeeve-platform/modal-component';
import { Breadcrumb } from '@zeeve-platform/breadcrumb-component';
import Network from './network';
import CloudConfiguration from './cloudConfiguration';
import Urls from '../../../utils/util';
import appSubPath from '../../../utils/helper';
import {
  addNodeData,
  getNetworkDetailData,
  getAvailableCountData,
} from '../../../services/apisService';
import Loading from '../../../components/common/loader';
import { AddNodePayload } from '../../../services/payloadTypes';
import { NetworkDataZoneTypes, CloudConfigDataZoneTypes } from '../declaration';
import CloudInfo from '../../../utils/cloudInfo';
import Badge from './Badge';

// Network Details Type
interface NetworkDetailsType {
  network: string;
  name: string;
  redirectionUrl: string;
  cloudId: string;
  deploymentTypeId: string;
  inputConfigurations: {
    region: string;
    cloud: string;
    managedHosting: boolean;
    gcpProjectId: string;
  };
  status: string;
}

// Props Types
interface Props {
  networkId: string;
}

const AddNodeBody = ({ networkId }: Props) => {
  const [pagenumber, setPageNumber] = useState(0);
  const [networkDataZone, setNetworkDataZone] = useState(
    {} as NetworkDataZoneTypes,
  );
  const [cloudConfigDataZone, setCloudConfigDataZone] = useState(
    {} as CloudConfigDataZoneTypes,
  );
  const [networkDetail, setNetworkDetail] = useState({} as NetworkDetailsType);
  const [isDisable, setIsDisable] = useState<boolean>(false);
  const [availableCount, setAvailableCount] = useState<number>(-1);
  const [loading, setLoading] = useState<boolean>(true);
  const [redirectionUrl, setRedirectionUrl] = useState<string>('');
  const [showLoader, setShowLoader] = useState(false);
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [addNodeResMsg, setAddNodeResMsg] = useState<string>('');
  const [first, setFirst] = useState(true);
  const [isClose, setIsClose] = useState<boolean>(false);

  const toNetwork = appSubPath(`/nodes/full/${networkId}`);
  const paths = [
    { name: 'Dashboard', path: Urls.getDashboardUrl() },
    { name: 'Dedicated Full Nodes', path: Urls.getAllNetworkUrl() },
    { name: networkDetail.name || 'loading', path: toNetwork },
  ];

  const zeeveManagedCloud:string = Urls.getZeeveManagedValue();

  const prev = () => {
    if (pagenumber === 0) {
      setFirst(true);
      setPageNumber(0);
    } else {
      setFirst(false);
      setStepDeactive(pagenumber);
      setPageNumber(pagenumber - 1);
      if (pagenumber === 0) {
        setFirst(true);
      }
    }
  };
  const nextP = () => {
    setFirst(false);
    if (pagenumber === 1) {
      setPageNumber(1);
    } else {
      setPageNumber(pagenumber + 1);
    }
  };

  const getInfraType = () => {
    if (networkDetail && networkDetail.inputConfigurations) {
      const cloudName = CloudInfo.getCloudById(networkDetail.cloudId);
      const { managedHosting } = networkDetail.inputConfigurations;
      if (managedHosting) {
        return zeeveManagedCloud;
      }
      return Urls.isByocEnabled() ? `BYOC-${cloudName}` : '';
    }
    return '';
  };

  useEffect(() => {
    onLoad();
  }, []);

  const onLoad = async () => {
    setShowLoader(true);
    setLoading(true);
    const filterArr: string[] = [];
    let card: any = [];
    const addOnArr: string[] = [];
    const response: any = await getNetworkDetailData(networkId);
    setShowLoader(false);
    if (response) {
      if (response.success) {
        const res = response.data;
        const obj: NetworkDetailsType = {
          network: res.network,
          name: res.name,
          redirectionUrl: res.redirectionUrl,
          cloudId: res.cloudId,
          deploymentTypeId: res.deploymentTypeId,
          inputConfigurations: {
            region: res.inputConfigurations.region,
            cloud: res.inputConfigurations.credId,
            managedHosting: res.inputConfigurations.managedHosting,
            gcpProjectId: res.inputConfigurations.gcpProjectId,
          },
          status: res.status,
        };
        setNetworkDetail(obj);
        const cloudName = CloudInfo.getCloudById(obj.cloudId);
        const { managedHosting } = obj.inputConfigurations;
        if (managedHosting) {
          filterArr.push(zeeveManagedCloud);
        } else if (Urls.isByocEnabled()) filterArr.push(`BYOC-${cloudName}`);
      }
    }
    if (filterArr && filterArr.length > 0) {
      const responseData: any = await getAvailableCountData(filterArr);
      setShowLoader(false);
      if (responseData) {
        if (responseData.success) {
          const cards = responseData.data;
          for (let i = 0; i < cards.length; i += 1) {
            if (cards[i].available_quantity > 0) {
              card = cards[i].attributes;
              setAvailableCount(cards[i].available_quantity);
              if (card.length > 0) {
                for (let j = 0; j < card.length; j += 1) {
                  addOnArr.push(card[j].addon_code);
                }
              }
              break;
            }
          }
          setLoading(false);
        } else {
          setAvailableCount(0);
          setLoading(false);
        }
      } else {
        setAvailableCount(0);
        setLoading(false);
      }
    } else {
      setLoading(false);
      setAvailableCount(0);
    }
  };

  const continueNext = () => {
    window.open(redirectionUrl, '_self');
  };

  const resetStep = () => {
    const s1 = document.getElementById('step1');
    if (s1) {
      s1.style.borderBottom = '0px solid #FFF';
    }
    const s4 = document.getElementById('step4');
    if (s4) {
      s4.style.borderBottom = '0px solid #FFF';
    }
  };
  const setStepActive = (n: number) => {
    for (let i: number = 1; i <= n + 1; i += 1) {
      const step = `step${i.toString()}${i.toString()}`;
      const ss: HTMLElement | null = document.getElementById(step);
      if (ss) {
        ss.style.opacity = '1';
        ss.style.backgroundColor = '#04AA6D';
      }
      if (i === n + 1 && ss) {
        ss.style.opacity = '1';
        ss.style.backgroundColor = '#FFC542';
      }
    }
  };
  const setStepDeactive = (n: number) => {
    const s = n + 1;
    const step = `step${s.toString()}${s.toString()}`;
    const ss = document.getElementById(step);
    if (ss) {
      ss.style.opacity = '0.5';
      ss.style.backgroundColor = 'rgba(23, 23, 23, 0.1)';
    }
  };

  const submit = async () => {
    setShowLoader(true);
    setIsDisable(true);
    const instanceArr = [
      {
        name: networkDataZone.instanceName,
        type: cloudConfigDataZone.instanceType,
        blockchainInputs: {
          http: networkDataZone.rpcAccessPoint.https,
          ws: networkDataZone.rpcAccessPoint.wss,
          authUser: networkDataZone.username,
          authPassword: networkDataZone.password,
          network: networkDetail.network,
          nodeType: networkDataZone.nodeOption,
        },
      },
    ];

    const mega: AddNodePayload = {
      networkId,
      credId: networkDetail.inputConfigurations.cloud,
      cloud: networkDetail.cloudId,
      region: networkDetail.inputConfigurations.region,
      managedHosting: networkDetail.inputConfigurations.managedHosting,
      instanceArray: instanceArr,
      workspaceId: networkDataZone.workspaceId,
      projectId: networkDetail.inputConfigurations.gcpProjectId,
    };
    const response: any = await addNodeData(mega, networkId);
    if (response) {
      setShowLoader(false);
      setIsDisable(false);
      setModalShow(true);
      if (response.success) {
        setIsClose(false);
        setAddNodeResMsg(response.data.message);
        setRedirectionUrl(response.data.redirectionUrl);
      } else {
        setIsClose(true);
        setAddNodeResMsg(response.message);
      }
    } else {
      setIsClose(true);
      setIsDisable(false);
      setShowLoader(false);
      setAddNodeResMsg('Error adding node');
      setModalShow(true);
    }
  };
  const showZone = () => {
    const s1: HTMLElement | null = document.getElementById('step1');
    const s4 = document.getElementById('step4');
    switch (pagenumber) {
      case 0:
        resetStep();
        setStepActive(pagenumber);
        if (s1) {
          s1.style.borderBottom = '2px solid #0062FF';
        }
        return (
          <Network
            networkId={networkId}
            last={false}
            submit={submit}
            first={first}
            prev={prev}
            networkDataZone={networkDataZone}
            setNetworkDataZone={setNetworkDataZone}
            nextPage={nextP}
          />
        );
      case 1:
        resetStep();
        setStepActive(pagenumber);
        if (s4) {
          s4.style.borderBottom = '2px solid #0062FF';
        }
        return (
          <CloudConfiguration
            last
            defaultValue={
              networkDetail.inputConfigurations
                ? networkDetail.inputConfigurations
                : {
                  region: '', cloud: '', managedHosting: false, gcpProjectId: '',
                }
            }
            submit={submit}
            cloudConfigDataZone={cloudConfigDataZone}
            cloudId={networkDetail ? networkDetail.cloudId : ''}
            setCloudConfigDataZone={setCloudConfigDataZone}
            first={first}
            prev={prev}
            nextPage={nextP}
            isDisable={isDisable}
          />
        );
      default:
        return (
          <Network
            networkId={networkId}
            last={false}
            networkDataZone={networkDataZone}
            submit={submit}
            first={first}
            prev={prev}
            setNetworkDataZone={setNetworkDataZone}
            nextPage={nextP}
          />
        );
    }
  };

  return (
    <section className="px-5 col-12">
      <div className="row">
        <div className="col-lg-3 col-xl-9 col-sm-12 col-xs-12 cursor">
          <p className="mt-3 breadcrumb-item mx-1 all-color">
            <span>
              <b>Node Configurations -</b>
            </span>
            <span className="mx-2 text-muted">{getInfraType()}</span>
          </p>
        </div>
        <div className="col-lg-3 col-xl-3 col-sm-12 col-xs-12 cursor">
          <p className="mt-3 breadcrumb-item mx-1 all-color">
            <span>
              <b>Available:</b>
            </span>
            <span className="mx-2 text-muted">
              {`${availableCount === -1 ? 'loading' : availableCount} Nodes`}
            </span>
          </p>
        </div>
      </div>
      <div className="mt-3">
        <div className="col-lg-3 col-xl-6 col-sm-12 col-xs-12 cursor">
          <Breadcrumb prefixLink={paths} activeLink="Add Node" textSize={13} />
        </div>
        {/* network list starts here */}
        <div className="card mt-4">
          <div className="card-body">
            <div className="navbar" style={{ justifyContent: 'left' }}>
              <h6 className="mt-4 ms-4">
                <div
                  className="borderline border-margin paddingbottom"
                  id="step1"
                >
                  <span className="step" id="step11" />
                  <span className="mx-2">Network</span>
                </div>
              </h6>
              <h6 className="mt-4 ms-4">
                <div className="border-margin paddingbottom" id="step4">
                  <span className="step" id="step44" />
                  <span className="mx-2 ">Cloud Configuration</span>
                </div>
              </h6>
            </div>
            <hr
              className="mt-4 choose-border"
              style={{ marginTop: '-18px !important' }}
            />
            {showLoader && <Loading />}
            {!loading && availableCount <= 0 && (
              <div className="mx-5 alert-danger mt-4 rounded text-center">
                <p
                  className="text-danger  py-2"
                  style={{ display: 'block' }}
                  id="etag"
                >
                  Do not have sufficient Nodes to deploy.
                  {' '}
                  <a href={Urls.getMarketplaceUrl()} className="text-primary cursor text-decoration-underline">Update your Subscription</a>
                </p>
              </div>
            )}
            {availableCount > 0 && showZone()}
          </div>
        </div>
      </div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Deployment Redirection"
        visibleFooter
        visibleFooterCloseButton={isClose}
        visibleHeaderCloseIcon={false}
        visibleConfirmBtn={redirectionUrl !== ''}
        confirmBtnText="Continue"
        onConfirm={continueNext}
        confirmBtnClassName=""
      >
        <Badge resMsg={addNodeResMsg} />
      </Modal>
    </section>
  );
};
export default AddNodeBody;
